import { render } from "./AdminManage.vue?vue&type=template&id=61455949&scoped=true&ts=true"
import script from "./AdminManage.vue?vue&type=script&lang=ts"
export * from "./AdminManage.vue?vue&type=script&lang=ts"

import "./AdminManage.vue?vue&type=style&index=0&id=61455949&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61455949"]])

export default __exports__